import React from "react";
import FinDocListPage from "../components/FinDocListPage";
import { queryFinDoc } from "../newApi/findoc.api";

export default function FinDocPendingFinance() {
  return (
    <FinDocListPage
      title="待財務處理"
      menuKey="FinDocPendingFinance"
      defaultStatuses={["pendingFinance"]}
      fetcher={queryFinDoc}
      extraFilters={(actor) => ({ next_auditor_mail: actor.email })}
      getActions={(record, actor, navigate) => [
        {
          label: "上傳歸檔",
          onClick: () => navigate(`/FinDoc/Finance/${record.findoc_no}`),
        },
      ]}
    />
  );
}